import { Injectable } from '@angular/core';
import { ToastComponent } from '../../shared/components/toast/toast.component';

@Injectable({
  providedIn: 'root'
})
export class ToastService {
  private toastComponent!: ToastComponent;

  constructor() { }
  
  setToastComponent(toastComponent: ToastComponent): void {
    this.toastComponent = toastComponent;
  }

  show(message: string, type: string = 'success', duration: number = 3000): void {
    this.toastComponent.showToast(message, type, duration);
  }
}  
